// removed by extract-text-webpack-plugin
module.exports = {"claim":"theme__claim___2W_mh","claimTitle":"theme__claimTitle___18vEK","claimImg":"theme__claimImg___1AeIp","fadeUp":"theme__fadeUp___nLuU2","lateFadeUp":"theme__lateFadeUp___2Aeob","lateFadeIn":"theme__lateFadeIn___hNXMr"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Strongest/Claim/theme.scss
// module id = 1309
// module chunks = 0